
	import { Vue } from 'vue-property-decorator';
	import { Observer } from 'mobx-vue';
	import Component from 'vue-class-component';
	import topCovers from '@/store/prescription/definition/categories/topCovers';
	import CategoryContainer from './CategoryContainer.vue';
	import PrescriptionItemSelect from '@/components/new-prescription/prescription-items/PrescriptionItemSelect.vue';
	import PrescriptionItemRadio from '@/components/new-prescription/prescription-items/PrescriptionItemRadio.vue';
	import PrescriptionItemRadioSelect from '@/components/new-prescription/prescription-items/PrescriptionItemRadioSelect.vue';
	import OtherModifications from '@/components/prescription/OtherModifications.vue';
	import { COVER_SPECIAL_RX } from '@/store/prescription/prescription-types';
	import PrescriptionItemSpecialRX from '@/components/new-prescription/prescription-items/PrescriptionItemSpecialRX.vue';
	@Observer
	@Component({
		components: {
			PrescriptionItemRadio,
			PrescriptionItemSelect,
			PrescriptionItemRadioSelect,
			CategoryContainer,
			OtherModifications,
			PrescriptionItemSpecialRX
		}
	})
	export default class TopCovers extends Vue {
		activated() {
			if (this.$route.query['showhelpmodal'] === 'true') {
				this.$state.prescription.setShowHelpSaverxModal('true');
			}
		}
		get coverSpecialRX() {
			return COVER_SPECIAL_RX;
		}
		deactivated() {
			this.$state.prescription.setShowHelpSaverxModal('false');
		}
		get top() {
			return topCovers;
		}
		getDisabledValues() {
			const disabledValues: Array<any> = [];
			const currentSavedRXTitle = this.$state.product.currentSavedRXTitle;
			const topCovers = this.$state.prescription.newPrescription.topCovers;

			if (currentSavedRXTitle === 'Accommodative') {
				if (topCovers.topCoverMaterial) {
					disabledValues.push('eva-black-1-6', 'eva-black-1-8', 'poly-u-1-8-vinyl', 'poly-u-1-16-vinyl');
				}
				if (topCovers.midLayerMaterial) {
					disabledValues.push('eva-black-1-16', 'eva-black-1-8', 'poly-u-1-8-scrim', 'poly-u-1-16-scrim');
				}
			}

			return disabledValues;
		}

		topCoverLengthDisabledValues() {
			const disabledOptionsList: Array<any> = [];
			const hasDisabler =
				this.$state.prescription.newPrescription.shellModifications.mortonsExtension.type !== 'none' ||
				this.$state.prescription.newPrescription.shellModifications.reverseMortonsExtension.type !== 'none' ||
				this.$state.prescription.newPrescription.shellModifications.shellLength === 'full';
			if (hasDisabler) {
				disabledOptionsList.push('met');
				disabledOptionsList.push('sulcus');
				this.$state.prescription.newPrescription.topCovers.topCoverLength = 'full';
			}
			if (this.$state.prescription.newPrescription.shellModifications.shellLength === 'sulcus') {
				disabledOptionsList.push('met');
			}
			return disabledOptionsList;
		}
	}
